import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/paddle/checkout")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/billing", replace: true });
  },
  head: () => ({
    meta: [{ title: "Billing - MultiResume" }],
  }),
});
